<script>
import { mapActions, mapMutations } from "vuex";
import Button from "@/components/Button";
import Loader from "@/components/Loader";

export default {
  name: "Material",
  props: { modal: Object },
  components: { Button, Loader },
  data() {
    return {
      show: false,
      loader: true,
      list: [],
      material: [],
      q: ""
    }
  },
  methods: {
    ...mapActions("user", ["MATERIAL_JOB"]),
    ...mapActions("admin", ["MATERIAL_SERVICETYPE"]),
    ...mapMutations("general", ["SET_STATUS"]),
    async add(i) {
      var item = this.list[i]
      delete item.up
      item.loader = true
      this.list = [...this.list]

      let { data } = item.id_job ? await this.MATERIAL_JOB({
        t: 'put',
        id: item.id,
        p: { etag: item.etag, quantidade: parseInt(item.quantidade) }
      }) : await this.MATERIAL_JOB({
        t: 'post',
        p: { id_material: item.id_material, id_job: this.modal.job.id, quantidade: parseInt(item.quantidade) }
      })
      if (data && data.id) {
        this.SET_STATUS({
          color: "green",
          text: "Material atualizado.",
        })
        this.list[i] = data
      } else this.load()
      this.list[i].loader = false
      this.list = [...this.list]

    },
    async del(i) {
      this.list[i].loader = true
      this.list = [...this.list]
      if (this.list[i].id_job)
        await this.MATERIAL_JOB({ t: 'del', id: this.list[i].id })
      this.list[i].loader = false
      this.load()
    },
    focus() {
      this.q = ""
      setTimeout(() => document.querySelectorAll('.Material .content .item input')[this.list.length-1].focus(), 500)
    },
    async load() {
      this.loader = true
      let { data } = await this.MATERIAL_JOB({ id: this.modal.job.id, t: 'get' })
      this.list = data || []
      this.loader = false
    }, close() {
      setTimeout(() => this.show = false, 200)
    }
  },
  mounted() {
    this.MATERIAL_SERVICETYPE({ t: 'get', id: this.modal.job.id_tipo_servico }).then(({ data }) => this.material = data || [])
    this.load()
  }
};
</script>

<template lang="pug">
.Material.row.col-s.ac-s
  .new.col.g4.g12-s.ac-s
      input(v-model="q" @blur="close" @focus="show=true" placeholder="Adicionar")
      .select.g11-s(v-if="show")
          .m.row(v-for="m in material.filter(m=>m.material.status=='ativo' && JSON.stringify(m).toLowerCase().includes(q.toLowerCase()))" @click="list.push(m);focus()") 
              b(style="flex:1") {{m.material.sku}} - {{m.material.nome}}
              b +
  .list.col.g8.g12-s
      .head.cp.row.g12.hide-s
          .g5 Nome
          .g4 Quantidade
          .g3
      .content
          .tc(v-if="list.length==0" style="font-size: 16px;color:#555;margin-top: 100px") Nenhum material cadastrado.
          Loader(v-if="loader" style="margin: 85px 40%")
          .item.row.ac(v-else v-for="item,i in list" title="ADICIONAR")
              .g5 {{item.material.nome}}
              .g4.row.ac.col-s
                input(v-model="item.quantidade" @input="item.up=true;list=[...list]" type="number" style="margin-right:12px" placeholder="Quantidade" required)
                b {{item.material.unidade=='unitario'?'Unitário':'Metro'}}
              .g3.row.ac.je(v-if="true")
                  Button(v-if="item.quantidade && item.up" @click="add(i)" layout="green-go" :loader="item.loader") Salvar
                  Loader(v-if="item.loader" layout="mini")
                  i.fa.fa-trash(v-else @click="del(i)" title="Excluir")

</template>

<style lang="sass">
@use "@/assets/scss/vars.scss" as *
.Material
  @include page
  background: #f1f1f1
  border-top: 2px solid #ddd
  border-radius: 20px
  padding: 20px
  margin-top: 15px
  overflow: auto
  @media (min-width: $small)
    min-width: 800px
  label
      @include label
  .item
      font-size: 14px
      color: $font-color
      padding: 12px 10px
      @media (min-width: $small)
        &:nth-child(even)
          background: #eee
      .fa-search
          margin-left: 6px
          margin-right: 20px
          &:hover
              color: $purple
      .fa-trash
          margin-left: 12px
          &:hover
            color: $red
            font-size: 20px
            cursor: pointer
      @media (max-width: $small)
        @include card
        border: none
        margin-bottom: 6px
        padding: 6px 15px
        border-radius: 8px
        .g12-s
          margin-bottom: 6px
          &:last-child
            margin-top: 20px
            justify-content: center
  .list
      margin: 0
      width: 85%
      min-width: 300px
      @media (min-width: $small)
        margin-left: 12px
      .head
          border-bottom: 1px solid $purple
          padding-bottom: 10px
          font-weight: bold
      .content
        .loader
            margin: 0
        @media (min-width: $small)
          max-height: 300px
      @media (max-width: $small)
        margin-top: 12px
        background: none
        padding: 8px
        border: none
        width: 95%
  .select
      border: 1px solid $purple
      margin-top: 4px
      background: white
      border-radius: 8px
      font-size: 13px
      max-height: 290px
      overflow: auto
      .m
          padding: 10px 6px
          &:nth-child(even)
              background: #eee
          &:hover
              cursor: pointer
              background: rgba($purple,.5)
              color: white
</style>